import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createRevenueRecognation,
  deleteRevenueRecognation,
  getRevenueRecognation,
  updateRevenueRecognation,
  verifyRevenueRecognation,
} from "libs/api/revenue_recognation";

// RevenueRecognation Thunk
export const getRevenueRecognationThunk = createAsyncThunk(
  "revenueRecognation/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getRevenueRecognation(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Create RevenueRecognation Thunk
export const createRevenueRecognationThunk = createAsyncThunk(
  "revenueRecognation/create",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    body,
    accessToken,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createRevenueRecognation(
        pathname,
        body,
        accessToken
      );
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Update RevenueRecognation Thunk
export const updateRevenueRecognationThunk = createAsyncThunk(
  "RevenueRecognation/update",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateRevenueRecognation(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Delete RevenueRecognation Thunk
export const deleteRevenueRecognationThunk = createAsyncThunk(
  "revenueRecognation/delete",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteRevenueRecognation(pathname);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Update RevenueRecognation Thunk
export const verifyRevenueRecognationThunk = createAsyncThunk(
  "revenueRecognation/verify",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    body,
    accessToken,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await verifyRevenueRecognation(
        pathname,
        body,
        accessToken
      );
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);
